import type { DetailedPreviewFiltersFormProps } from './types'

export const consolidatedPreviewFiltersInitialFormValues: DetailedPreviewFiltersFormProps = {
  account: [],
  deviationType: [],
  status: [],
  weeks: []
}
